export const types = {
    add: '[todo] add',
    delete: '[todo] delete',
    toggle: '[todo] toggle',
    deleteAll: '[todo] deleteAll'
}